import env from "@/env";
import { addHours, isBefore } from "date-fns";

export const isLessonCancellationFree = (lesson: LinkedLesson): boolean => {
  return isBefore(addHours(new Date(), env.REACT_APP_LESSON_CANCELLATION_MIN_HOURS), lesson.startDateTime);
};
